import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { QuestionsApi } from "../../api/questions/QuestionsApi";
import { saveAs } from "file-saver";

export default function () {
	const onClick = async () => {
		const response = (await QuestionsApi.exportQuestions()) as any;
		saveAs(response.data, "questions.zip");
	};

	return (
		<Grid container>
			<Grid item xs={12} sx={{ marginBottom: "10px" }}>
				<Typography variant={"subtitle2"}>Экспорт архива файлов задач</Typography>
			</Grid>
			<Grid item xs={12}>
				<Button onClick={onClick} variant={"contained"}>
					Экспортировать
				</Button>
			</Grid>
		</Grid>
	);
}
